export default "__VITE_ASSET__ButngqMJ__"